<template>
  <div :class="'scoreLine '+rowStyle">
     <div class="cell level">{{index}} </div>
    <div class="cell name" style="flex-grow:1">{{score.Name}}</div>
    <div v-if="showDifficulty"  class="cell difficulty">{{score.Difficulty}} </div> 
    <div class="cell score">{{score.score}} </div>
    <div class="cell level">{{score.Level}} </div>
    
     <div class="cell hits">{{score.BallsHit}} </div>
     <div class="cell hits">{{score.BallsScored}} </div>
  </div>
</template>

<script>
export default {
  name: 'textInput',
  props:  {
        score: {
            type: Object,
            required: true,
        },
        index: {
            type: String,
            required: false,
            default:"Rank"
        },
       HR: {
            type: String,
            default: "",
        },
        showDifficulty: {
            type: Boolean,
            default: false,
        },
  },

  computed:{
    
    totalScore(){
      return this.score.BallsHit+this.score.BallsScored*5 || ""
    },
    rowStyle(){
      if(this.HR){
        return "header "+this.HR
      }
      return this.HR
    }
  },
  methods:{
    

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";
 .scoreLine{
   display:flex;
   text-align: left;
   border:none;
  width:100% ;
  padding: 13px 1em;
  color:#000;
  background-color: #FFFEDB;
  margin-top: 5px;
  overflow-x:hidden;
  /*border-bottom:solid  #F00 5px;*/
  
  
   .cell{
     min-width: 2.8em;
     text-align: left;     
   }
   .name{
     width:140px;
     
   }
   .score{
     width:3.5em;
   }
   .hits{
     width:2.8em;
   }
   .level{
     width:3.4em;
     
   }
   
    .difficulty{
     min-width:8em;
     text-align: left;
   }
 }
 .scoreLine.header{
   background-color:$advanced-color;
   color:#000;
   font-weight: 700;
   text-transform: uppercase;
   margin-top:0px;
   
   
 }

 .scoreLine.header.Intermediate{
   background-color:$intermediate-color;
 }
 .scoreLine.header.Beginner{
   background-color:$beginner-color;
 }
 .scoreLine.header.Novice{
   background-color:$novice-color;
 }
 .scoreLine.header.Relaxed{
   background-color:$relaxed-color;
   border-color:$relaxed-color;
 }
 .scoreLine.header.Global{
  background-color:$global-color;
 }
  .scoreLine.Intermediate{
   background-color:$intermediate-color;
 }
 .scoreLine.Beginner{
   background-color:$beginner-color;
 }
 .scoreLine.Novice{
   background-color:$novice-color;
 }
 .scoreLine.Relaxed{
   background-color:$relaxed-color;
  
 }

</style>
